import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, role }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center text-[#64748B]" data-testid="auth-loading">
                Laden…
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (role && user.role !== role) {
        // If admin lands on /employee or vice versa, redirect them
        return <Navigate to={user.role === "admin" ? "/admin" : "/employee"} replace />;
    }
    return children;
}
